<template>
  <div class="content">
    <h2 style="margin:20px">仪器列表</h2>
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-button type="primary" size="mini" @click="addBtn">新增</el-button>
        <el-button size="mini" @click="handleCreateSaleCode">下载页面小程序码</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <el-table
      :data="dataList"
      style="width: 100%;overflow-y: scroll;"
      height="calc(100vh - 220px)"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>

      <el-table-column label="仪器名称" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.boxNo }}</span>
        </template>
      </el-table-column>
      <el-table-column label="仪器uuid" align="center" width="450">
        <template slot-scope="scope">
          <span>{{ scope.row.uuid }}</span>
        </template>
      </el-table-column>
      <el-table-column label="价格" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.price ? scope.row.price : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="打开页面链接" align="center" width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.pageUrl? scope.row.pageUrl : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="ejectupdateGoods(scope.row)">修改</el-button>
          <el-button size="mini" type="text" @click="deleteAdmin(scope.row)" style="color:red">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增表单 -->
    <el-dialog :title="inputTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="仪器名称" required>
          <el-input v-model="form.boxNo" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="仪器uuid" required>
          <el-input v-model="form.uuid" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="价格">
          <el-input
            v-model="form.price"
            auto-complete="off"
            type="number"
            aria-placeholder="不填写则为免费测量仪器"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="扫码后打开页面" required>
          <el-select v-model="form.pageUrl" placeholder="请选择" clearable style="width:100%">
            <div v-for="item in pageUrlList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectApi,
  deleteApi,
  addApi,
  updateApi
} from "@/services/instrument_list/index.js";
import { createCode } from "@/services/system/getCode.js";
export default {
  data() {
    return {
      dataList: [],
      inputTitle: "新增",
      cover: "",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      pageUrlList: [
        { name: "仪器页面", id: "pages/instrument/instrument" },
        { name: "问答页面仪器", id: "pages/chatView/chatView" }
      ],
      form: {},
      dialogFormVisible: false
    };
  },
  created() {
    this.selectData();
  },
  methods: {
    // 查询
    selectData() {
      selectApi().then(resp => {
        this.loading = false;
        this.dataList = resp.data;
      });
    },

    // 新增按钮
    addBtn() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {
        pageUrl: "pages/instrument/instrument"
      };
    },
    ejectupdateGoods(row) {
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
    },

    sumbmitBtn() {
      console.log("this.form", this.form);
      if (!this.form.boxNo || !this.form.uuid) {
        this.$message.error("请填写测量仪器名称和编码");
        return;
      }
      if (!this.form.id) {
        addApi(this.form).then(res => {
          if (res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: "新增成功!"
            });
            this.selectData();
          }
        });
        return;
      }

      updateApi(this.form).then(res => {
        if (res.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.selectData();
        }
      });
    },

    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteApi(row.id).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.selectData();
          });
        })
        .catch(() => {});
    },

    /* 销售二维码 */
    handleCreateSaleCode(row) {
      createCode({
        boxNo: 1,
        pageUrl: "pages/instrument/instrument"
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "创建成功,前往下载!"
          });

          setTimeout(() => {
            window.open(res.data, "_blank");
          }, 1000);
        } else {
          this.$message({
            type: "error",
            message: res.data
          });
        }
      });
    }
  }
};
</script>

<style>
.content {
  margin: 10px auto;
  width: 98%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.userNanme:hover {
  cursor: pointer;
}
</style>
